export default {
  menu: 'Receives',
  title: 'Receives',

  general: {
    statusTypes: {
      all: 'All',
      confirm: 'Confirmed',
      cancel: 'Canceled'
    },

    receiveTypes: {
      cash: 'Cash',
      bank: 'Bank transfer',
      paymentGateway: 'Gateway or POS'
    },

    types: {
      cash: 'fund',
      bank: 'bank',
      user: 'User',
      storeroom: 'Store',
      paymentGateway: 'payment gateway'
    },

    status: {
      confirm: 'Confirm',
      reject: 'Refund',
      draft: 'Draft'
    },

    labels: {
      all: 'All',
      receiveType: 'Receipt type',
      user: 'Receive from',
      cash: 'deposit to fund',
      bank: 'Deposit to bank',
      paymentGateway: 'Deposit to gateway',
      price: 'Amount',
      date: 'Date of deposit',
      description: 'Description',
      transactionsReferenceId: 'Tracking number',
      balance: 'Wallet balance',
      wallet: 'Wallet',
      credit: 'Credit',
      debt: 'Debt',
      invoiceCredit: 'Current invoice credit',
      remainingPrice: 'Remaining price'
    },

    placeholder: {
      date: 'Automatic'
    },

    table: {
      header: {
        restore: 'Restore',
        delete: 'Delete',
        status: 'Status',
        price: 'Amount',
        destination: 'Payee',
        source: 'Payer',
        description: 'Documents',
        creator: 'Creator',
        date: 'Date',
        referenceId: 'Reference id',
        docNumber: 'Document number',
        row: 'Row'
      }
    },

    notifications: {
      cantReturn: 'This receive cant be refund',
      invalidType: 'Receipt type not selected',
      invalidUser: 'Person not selected',
      invalidPrice: 'Amount not entered',
      lessPrice: 'The amount entered should not be less than {price} {currency}',
      invalidDescription: 'Receipt description not entered',
      invalidTransactionsReferenceId: 'Incorrect tracking number entered',
      invalidCash: 'Inbox not selected',
      invalidBank: 'Bank not selected',
      invalidPaymentGateway: 'Port not selected',
      incorrect_reference_id: 'reference id is not correct',

      insert: {
        success: 'Receipt created successfully',
        error: 'Creating a receive with an error'
      },
      delete: {
        success: 'Receipt information successfully deleted',
        error: 'Deleting the received information was accompanied by an error'
      },
      restore: {
        success: 'Receipt information successfully restored',
        error: 'Restore the received information was accompanied by an error'
      },
      print: {
        success: 'Your request has been sent, please wait',
        error: 'The print request has error'
      },
      return: {
        success: 'Receipt refund create successfully',
        error: 'Create receive refund has error'
      },
      parseError: {
        name: 'The selected name is not valid!',
        price: 'The selected amount is not valid!',
        referenceId: 'The tracking number entered has already been used!',
        paymentGateway: 'The selected payment gateway is not valid!'
      }
    },

    confirmations: {
      delete: {
        title: 'Confirm Delete receive',
        body: 'Are you sure you want to delete this receive completely?'
      },
      return: {
        title: 'Confirm Refund receive',
        body: 'Are you sure you want to refund this receive?'
      }
    },

    validators: {
      dateHelp: 'The entry must be entered as {date}.',
      date: 'The receive date is not entered correctly!',
      future: 'It is not possible to register a receive for the future'
    }
  },

  insert: {
    title: 'New Receive',
    dynamicTitle: 'Receive from {name}',

    suggests: {
      description: 'Received from {user} for {subject}'
    },

    table: {
      header: {
        row: 'Row',
        name: 'Name',
        price: 'Price'
      }
    }
  },

  list: {
    title: 'Receives'
  },

  trash: {
    title: 'Removed Receives List'
  },

  document: {
    title: 'Receipt',
    dynamicTitle: 'Receive No. {docNumber}',

    labels: {
      sources: 'Payer / payers',
      destinations: 'Recipient / recipients',
      details: 'Other information',
      referenceId: 'Reference id',
      creator: 'creator',
      status: 'Status',
      date: 'Registration date',
      description: 'Description',
      attachments: 'Attachments'
    }
  },

  return: {
    title: 'Insert Receive Refund',

    labels: {
      user: 'Pay to',
      date: 'Date',
      source: 'Payment from',
      receivePrice: 'Receive amount',
      price: 'Amount',
      description: 'Description',
      descriptionText: 'Receive refund for receive No. {id}'
    }
  },

  logs: {
    title: 'Receive logs'
  }
}
